export default "__VITE_ASSET__CoP34tyN__"